import { NavLink } from "react-router-dom";
import { useI18n } from "@/i18n/I18nContext";
import { openCookiePrefs } from "@/components/CookieBanner";

export default function Footer() {
  const { lang, t } = useI18n();
  const base = `/${lang}`;

  const legalHrefs = lang === "ar"
    ? { privacy: "/ar/privacidad", cookies: "/ar/cookies", terms: "/ar/terminos" }
    : { privacy: "/en/privacy", cookies: "/en/cookies", terms: "/en/terms" };

  return (
    <footer className="bg-[#121316] text-[#E5E3DC]" style={{ wordBreak: "break-word" }}>
      <div className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-12 pt-20 pb-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-3 text-[#F8F7F4]">
              <svg width="34" height="34" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden>
                <path d="M8 10H32L12 30H32" stroke="currentColor" strokeWidth="3.5" strokeLinecap="square" strokeLinejoin="miter"/>
                <path d="M8 10V22M32 18V30" stroke="#C27835" strokeWidth="2.5" strokeLinecap="square"/>
              </svg>
              <span className="font-serif text-xl tracking-[0.14em] uppercase">Zantravela</span>
            </div>
            <p className="mt-5 font-serif text-2xl sm:text-3xl leading-[1.2] text-[#F8F7F4] max-w-md">
              {t("footer.tagline")}
            </p>
            <p className="mt-8 text-xs font-mono uppercase tracking-[0.2em] text-[#7A7B82]">
              {t("footer.companyIncorporation")}
            </p>
          </div>

          <div className="lg:col-span-2">
            <h4 className="text-[11px] font-mono uppercase tracking-[0.24em] text-[#7A7B82]">{t("footer.columnNav")}</h4>
            <ul className="mt-5 space-y-3 text-sm">
              <li><a href={`${base}#what`} data-testid="footer-link-what" className="hover:text-[#C27835] transition-colors duration-200">{t("nav.what")}</a></li>
              <li><a href={`${base}#how`} data-testid="footer-link-how" className="hover:text-[#C27835] transition-colors duration-200">{t("nav.how")}</a></li>
              <li><a href={`${base}#projects`} data-testid="footer-link-projects" className="hover:text-[#C27835] transition-colors duration-200">{t("nav.projects")}</a></li>
              <li><a href={`${base}#trust`} data-testid="footer-link-trust" className="hover:text-[#C27835] transition-colors duration-200">{t("nav.trust")}</a></li>
              <li><a href={`${base}#contact`} data-testid="footer-link-contact" className="hover:text-[#C27835] transition-colors duration-200">{t("nav.contact")}</a></li>
            </ul>
          </div>

          <div className="lg:col-span-2">
            <h4 className="text-[11px] font-mono uppercase tracking-[0.24em] text-[#7A7B82]">{t("footer.columnLegal")}</h4>
            <ul className="mt-5 space-y-3 text-sm">
              <li><NavLink to={legalHrefs.privacy} data-testid="footer-link-privacy" className="hover:text-[#C27835] transition-colors duration-200">{t("footer.linkPrivacy")}</NavLink></li>
              <li><NavLink to={legalHrefs.cookies} data-testid="footer-link-cookies" className="hover:text-[#C27835] transition-colors duration-200">{t("footer.linkCookies")}</NavLink></li>
              <li><NavLink to={legalHrefs.terms} data-testid="footer-link-terms" className="hover:text-[#C27835] transition-colors duration-200">{t("footer.linkTerms")}</NavLink></li>
              <li><a href="/sitemap.xml" data-testid="footer-link-sitemap" className="hover:text-[#C27835] transition-colors duration-200">{t("footer.linkSitemap")}</a></li>
              <li><button type="button" onClick={openCookiePrefs} data-testid="footer-link-cookie-prefs" className="text-left hover:text-[#C27835] transition-colors duration-200">{t("cookies.manage")}</button></li>
            </ul>
          </div>

          <div className="lg:col-span-3">
            <h4 className="text-[11px] font-mono uppercase tracking-[0.24em] text-[#7A7B82]">{t("footer.columnCompany")}</h4>
            <ul className="mt-5 space-y-3 text-sm text-[#B4B5BB]">
              <li className="text-[#F8F7F4] font-medium">{t("footer.companyName")}</li>
              <li>{t("footer.companyReg")}</li>
              <li className="font-mono text-xs">{t("footer.companyCuit")}</li>
              <li>{t("footer.companyLicense")}</li>
              <li>{t("footer.companyAddress")}</li>
              <li>{t("footer.companyJurisdiction")}</li>
              <li><a href="mailto:hola@zantravela.com" data-testid="footer-email" className="hover:text-[#C27835] transition-colors duration-200">hola@zantravela.com</a></li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-[#2A2B30] grid grid-cols-1 lg:grid-cols-12 gap-6 items-start">
          <p className="lg:col-span-9 text-xs text-[#7A7B82] leading-relaxed">
            {t("footer.riskDisclosure")}
          </p>
          <p className="lg:col-span-3 text-xs text-[#7A7B82] lg:text-right">
            {t("footer.rights")}
          </p>
        </div>
      </div>
    </footer>
  );
}
